import { flow, map, toPairs, toUpper, union } from 'lodash/fp';
import prepareOptions, { prepareSortedOptions } from '../../prepareOptions';
import { MAKE_OTHER_VALUE } from '../make';

const MODEL_OTHER = {
  label: __('search.vehicleOptions.other'),
  value: MAKE_OTHER_VALUE,
};

export const getModelOptions = flow(
  toPairs,
  map(([value, label]) => ({ value: toUpper(value), label })),
  prepareSortedOptions,
  union(prepareOptions([MODEL_OTHER])),
);
